import React, { useState } from 'react';
import { Panel, PanelTheme, MultilineTextBox } from '@apply/components';

export const MultilineTextBoxDemo: React.FC = () => {
    // State for each example
    const [basicValue, setBasicValue] = useState('');
    const [readOnlyValue, setReadOnlyValue] = useState('Read only value');
    const [requiredValue, setRequiredValue] = useState('');
    const [basicValueWithBubble, setBasicValueWithBubble] = useState('');

    return (
        <div style={{ marginTop: '0px', marginBottom: '20px' }}>
            <h2>Multiline Text Box :</h2>
            <br />
            <Panel theme={PanelTheme.White}>
                <div style={{ padding: '1rem' }}>
                    {/* Example 1: Basic Multiline Textbox */}
                    <div style={{ marginBottom: '1rem' }}>
                        <MultilineTextBox
                            value={basicValue}
                            onChange={setBasicValue}
                            label='Basic TextBox'
                        />
                    </div>

                    {/* Example 2: Read-Only Multiline Textbox */}
                    <div style={{ marginBottom: '1rem' }}>
                        <MultilineTextBox
                            value={readOnlyValue}
                            onChange={setReadOnlyValue}
                            label='Read-Only TextBox'
                            readOnly={true}
                        />
                    </div>

                    {/* Example 3: Required Field */}
                    <div style={{ marginBottom: '1rem' }}>
                        <MultilineTextBox
                            value={requiredValue}
                            onChange={setRequiredValue}
                            label='Required TextBox'
                            required={true}
                        />
                    </div>

                    {/* Example 1: Basic Multiline Textbox */}
                    <div style={{ marginBottom: '1rem' }}>
                        <MultilineTextBox
                            value={basicValueWithBubble}
                            onChange={setBasicValueWithBubble}
                            label='Basic TextBox With Bubble'
                            showInfoIcon={true}
                            infoText='Basic TextBox With Bubble'
                        />
                    </div>
                </div>
            </Panel>
        </div>
    );
};
